<template>
  <div>
    <div class="fengxian">
      <h2>证券投资顾问服务协议</h2>

      <p>协议编号：{{ agreementNo }}</p>

      <p>甲方：{{ name }}（证券投资咨询业务资格证号: {{ certificateNo }}）</p>

      <p>负责人：{{ principal }}</p>

      <p>公司地址：{{ ads }}</p>

      <p>联系电话：{{ phone }} 投诉电话：{{ complaintsPhone }}</p>

      <p>乙方： {{ userName }}</p>

      <p>身份证号码： {{ idCard }}</p>

      <p>手机号： {{ userphone }}</p>

      <p>
        根据《中华人民共和国证券法》、《中华人民共和国合同法》和《证券投资顾问业务暂行规定》等相关法律法规，以及中国证券业协会（以下称证券业协会）的有关自律规则，甲、乙双方本着平等自愿，诚实守信的原则，就甲方向乙方提供证券投资顾问服务(以下简称"投顾产品/服务)事项，签订本协议，并共同遵守。
      </p>

      <p>第一章 声明与保证</p>

      <p>
        第一条
        甲方系国家证券主管机关核准的证券投资咨询专业机构；具备为投资者（客户）提供证券投资顾问服务的必要条件和专业能力。
      </p>

      <p>
        第二条
        甲方所提供的投顾产品/服务仅供乙方参考，乙方应自主作出投资决策，并独立承担投资风险。甲方不接受乙方的全权委托、不对乙方的投资收益或亏损进行任何形式的保证。
      </p>

      <p>
        第三条
        甲方就乙方是否适合购买/接受本投顾产品/服务而做出的适当性匹配意见并不代表甲方对乙方购买/接受本投顾产品/服务的风险和收益做出实质性判断和保证。
      </p>

      <p>
        第四条
        乙方系证券市场合法投资者，具有签订及履行本协议义务所需的完全民事权利能力和完全民事行为能力。
      </p>

      <p>
        第五条
        乙方已仔细阅读并完全理解和认可甲方提供的《证券投资顾问业务风险揭示书》等相关合规风控文件；乙方已了解本协议的所有条款并准确理解其含义，乙方已理解投资可能需要承担的风险与提示，具有相应的风险承受能力，无论该风险为已有风险或潜在风险。
      </p>

      <p>
        第六条
        乙方进行任何投资，包括其投资判断及决策，并不依赖于甲方或其员工提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务，而是在甲方的辅助下，经过深思熟虑作出独立判断及决策。乙方根据甲方证券投资顾问服务及软件工具、终端设备载体所提供的所有信息数据以及市场研究分析、投资建议等资料或产品所做出的决定和投资而造成的可能损失，由乙方自行承担，收益也自行享有。
      </p>

      <p>
        第七条
        甲、乙双方共同遵守国家的法律、法规，不利用本协议的关系从事任何违法、违规行为。
      </p>

      <p>第二章 产品和服务信息</p>

      <p>
        第八条
        在本协议有效期内，甲方向乙方提供的投顾产品/服务内容包括：市场研究分析报告、投资品种选择、投资策略、投资组合建议以及其他证券投资顾问产品等一项或若干项投资顾问服务。具体产品/服务名称、服务方式/渠道、提供时间和产品风险等级、适用客户等投顾产品/服务信息以乙方签约购买时该产品/服务页面展示的相关信息为准。甲方将依照本协议及具体该产品/服务页面展示信息的约定向乙方提供证券投资顾问服务。
        本次乙方签约购买产品/服务的具体信息如下：
      </p>

      <p>1、 产品/服务名称：{{ Nickname }}</p>

      <p>2、 产品/服务期限：{{ date }}-{{ newDate }}</p>

      <p>3、 产品/服务费用：{{ price }}</p>

      <p>
        第九条
        甲方向乙方提供服务采用如下方式：通过互联网、终端或软件、电话、短信、邮件、面对面咨询等方式。
      </p>

      <p>
        第十条
        产品/服务期限，以乙方购买时所选择服务期限为准。产品/服务到期后，客户有意继续购买的，需重新签署证券投资顾问服务协议。
      </p>

      <p>
        第十一条
        服务费用和支付方式：产品/服务的付费方式为现金预付费制，乙方应于本协议签订时支付费用，具体金额以乙方购买产品/服务时甲方系统中标明的价格为准。乙方可在甲方提供的支付方式（包括第三方支付、网银、转账汇款等方式）中自行选择并支付上述费用。
      </p>

      <p>第三章 甲方的权利和义务</p>

      <p>
        第十二条 甲方本着勤勉尽责、诚实守信的原则，为乙方提供专业、有偿服务。
      </p>

      <p>
        第十三条
        甲方有权根据提供的证券投资咨询顾问服务和本协议约定收取证券投资顾问服务费。
      </p>

      <p>
        第十四条
        甲方享有所提供的证券投资顾问服务内容的知识产权及其他相关权利，未经甲方书面许可，乙方不得对甲方提供的服务内容进行模仿、复制、传播、转发或提供给其他第三方，否则应当承担相应的违约责任。因乙方的前述行为给第三方造成的不利后果，甲方不承担任何责任；若甲方因此而承担责任的，甲方有权向乙方追偿。
      </p>

      <p>
        第十五条
        甲方倡导理性投资，向乙方提供的证券投资顾问服务内容，仅供乙方参考，甲方不向乙方承诺证券投资收益。
      </p>

      <p>
        第十六条
        甲方及其员工不代理乙方从事证券买卖或代替乙方做出投资决策；不与乙方约定分享投资收益或者分担投资损失，也不以任何方式对乙方承诺或保证证券投资收益。
      </p>

      <p>
        第十七条
        甲方所提供的证券投资顾问服务内容应当具有相关合理的依据并经科学、合理论证，无虚假、片面和误导性的陈述。投资建议的依据包括证券研究报告或者基于证券研究报告、理论模型以及分析方法形成的投资分析意见等。
      </p>

      <p>
        第十八条
        甲方向乙方提供证券投资顾问服务，忠实于乙方利益，不为自己买卖股票及具有股票性质、功能的证券以及期货；不利用咨询服务与他人合谋操作市场或者进行内幕交易。
      </p>

      <p>
        第十九条 甲方依法保护因服务关系而知悉的有关乙方的财产状况及其个人隐私。
      </p>

      <p>第四章 乙方的权利与义务</p>

      <p>
        第二十条
        在本协议有效期内，乙方有权按照本协议约定，接受甲方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务。未经甲方同意，乙方不得转让其在本协议下的任何权利义务。
      </p>

      <p>
        第二十一条
        乙方应当全面、准确、及时地向甲方提供与接受证券投资顾问服务有关的各种信息和文件资料，并认真如实填写《客户投资风险承受能力评估表》，按国家规定披露自身身份、财产与收入状况、证券投资经验、投资风险承受能力等，并对所提供信息和资料的真实性、准确性和完整性负责，以便于甲方评估乙方的风险承受能力，但甲方的风险评估结论仅供参考。若乙方须提供的信息发生变化，应及时通知甲方，以便甲方作相应调整。
      </p>

      <p>
        第二十二条
        乙方应向甲方提供有效的联系方式和服务获取方式，如有变动须提前三个工作日书面通知甲方。若未及时告知联系方式及服务获取方式变动情况，或因乙方其他自身原因，或因不可抗力因素，导致乙方未能及时获得甲方提供的证券投资顾问服务，因此而产生的不利后果由乙方自行承担。
      </p>

      <p>
        第二十三条
        乙方有权决定是否采用甲方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务。乙方须基于独立判断、自行决定证券投资，自享投资收益、自行承担投资损失。
      </p>

      <p>
        第二十四条
        乙方应妥善保管证券账户、资金账户和相应的密码，不得委托甲方或者甲方的员工保管其账户、代理其买卖证券。乙方不得与甲方或者甲方的员工另行达成证券投资收益共享、损失分担的约定。
      </p>

      <p>
        第二十五条
        乙方不得将甲方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务内容泄露给任何第三人，如有违反，甲方有权提前终止本协议并追索由此而给甲方造成的经济损失。
      </p>

      <p>第二十六条 乙方应根据本协议约定向甲方支付证券投资顾问费。</p>

      <p>第五章 保密条款</p>

      <p>
        第二十七条
        甲方对因提供本协议约定的服务内容而知悉的乙方个人财产状况等其他个人资料负有保密义务，未经乙方事先书面许可，不得向第三方提供。但因监管机关要求及司法需要等原因除外。
      </p>

      <p>
        第二十八条
        甲方因向乙方提供投资建议，知悉乙方做出具体投资决策的，不得向第三方泄露。
      </p>

      <p>
        第二十九条
        甲方因履行本协议而向乙方提供的市场研究分析报告、投资建议或相关信息及其他证券投资顾问服务内容，乙方负有保密义务，未经甲方事先书面许可，不得向第三方提供。
      </p>

      <p>第六章 不可抗力</p>

      <p>
        第三十条
        对于甲方无法预测或无法控制的设备故障、通讯故障及其它人力不可抗力而造成服务中断的情况，甲方不承担责任，但应尽快将发生不可抗力事故的情况通知乙方，并在乙方要求时提供有关证明文件。
      </p>

      <p>第七章 违约责任</p>

      <p>
        第三十一条
        甲方未能按本协议约定向乙方提供证券投资顾问服务的，则乙方有权要求补齐服务期限与服务内容。
      </p>

      <p>
        第三十二条
        乙方未能按本协议约定支付证券投资顾问费的，甲方有权暂停提供服务，双方约定的服务期不予顺延。
      </p>

      <p>
        第三十三条
        若甲方有证据证明，乙方违反了本协议第十四条或其他相关条款约定的，甲方有权终止本协议，不承担违约责任。甲方向乙方发出书面终止通知书后，协议终止，甲方无需向乙方退还任何费用，乙方应付费用甲方仍有权全额追收。
      </p>

      <p>
        第三十四条
        乙方同意保障和维护甲方及其他客户的利益，如因乙方违反有关法律、法规或合同约定给甲方及其他客户造成损失的，乙方须承担赔偿责任。
      </p>

      <p>第八章 协议的生效、变更和终止</p>

      <p>
        第三十五条
        本协议经双方电子或书面签名（盖章）确认，服务期满自行终止。经双方协商同意，本协议可提前终止，也可另行续签。
      </p>

      <p>
        第三十六条
        自签订本协议之日起5个工作日内，乙方可以书面通知方式提出解除协议。甲方收到乙方解除协议书面通知时，本协议解除。
      </p>

      <p>
        第三十七条
        本协议签署生效后，若有关法律、法规及行业规定已修订，本协议涉及内容及条款按新修订的法律法规执行，但其它内容及条款继续有效。如本协议与新的法律法规严重背离双方有义务在体现原协议要义的基础上修改本协议，或重新签署协议。
      </p>

      <p>第三十八条 甲乙双方经协商同意，可以修改本协议。</p>

      <p>第九章 争议的解决</p>

      <p>
        第三十九条
        凡因执行本协议所发生的或与本协议有关的一切争议，甲乙双方应本着善意的原则通过友好协商解决。协商不成的，应提交深圳仲裁委员会，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方均有约束力。仲裁费由败诉方负担。
      </p>

      <p>
        第四十条
        在争议处理过程中，除正在进行审理的部分外，协议的其它部分将继续执行，任何一方不得因发生争议故意损害或恶意诋毁另一方，不得威逼、利诱、恐吓对方，不得干扰和破坏对方的工作、学习和生活，如果违背本条款必须向对方赔付违约金。
      </p>

      <p>第十章 附则</p>

      <p>
        第四十一条
        《证券投资顾问业务风险揭示书》为本协议附件，系本协议不可分割的组成部分，与本协议具有同等法律效力。凡与本协议有冲突之处，均以本协议约定为准。
      </p>

      <p>第四十二条 本协议一式二份，甲乙双方各执一份，具有同等的法律效力。</p>
      <div>
        <p>甲方盖章</p>
        <p>乙方签名</p>
      </div>
      <div>
        <p>签署日期</p>
        <p style="padding-bottom: 2rem">签署日期</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { getUrlParams } from "@/utils/utility";
import api from "@/api/mall";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
var picHost = process.env.VUE_APP_PIC_BASE_URL;
export default {
  data() {
    return {
      active: 0,
      show: false,
      touchPressed: false,
      ctx: null,
      strokeStyle: "#EE2F2F",
      lineWidth: 2,
      lastX: null,
      lastY: null,
      canvas: null,
      goodsImageList: [],
      imageListLength: "",
      name: "",
      certificateNo: "",
      principal: "",
      ads: "",
      phone: "",
      complaintsPhone: "",
      imgUrl: "",
      ctime: "",
      idCard: "",
      userphone: "",
      userName: "",
      list: [],
      price: "",
      Nickname: "",
      time: "",
      date: "",
      newDate: "",
      agreementNo: "",
    };
  },
  mounted() {
    if (userAgent.android) {
      this.$bridge.registermethod("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge((bridge) => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
  },
  created() {
    if (!sessionStorage.getItem("a")) {
      this.active = 0;
    } else if (!sessionStorage.getItem("b")) {
      this.active = 1;
    } else if (!sessionStorage.getItem("c")) {
      this.active = 2;
    }
    this.Nickname = this.$route.query.name;
    this.time = this.$route.query.time;
    var now = new Date();
    if (this.time == "包年") {
      var newDate = this.DateAdd("y ", 1, now);
      var year = newDate.getFullYear();
      var month = newDate.getMonth() + 1;
      var ri = newDate.getDate();
      if (month < 10) month = "0" + month;
      if (ri < 10) ri = "0" + ri;
      this.newDate = year + "." + month + "." + ri;
    } else if (this.time == "6个月") {
      var newDate = this.DateAdd("m ", 6, now);
      var year = newDate.getFullYear();
      var month = newDate.getMonth() + 1;
      var ri = newDate.getDate();
      if (month < 10) month = "0" + month;
      if (ri < 10) ri = "0" + ri;
      this.newDate = year + "." + month + "." + ri;
    } else if (this.time == "3个月") {
      var newDate = this.DateAdd("m ", 3, now);
      var year = newDate.getFullYear();
      var month = newDate.getMonth() + 1;
      var ri = newDate.getDate();
      if (month < 10) month = "0" + month;
      if (ri < 10) ri = "0" + ri;
      this.newDate = year + "." + month + "." + ri;
    } else if (this.time == "1个月") {
      var newDate = this.DateAdd("m ", 1, now);
      var year = newDate.getFullYear();
      var month = newDate.getMonth() + 1;
      var ri = newDate.getDate();
      if (month < 10) month = "0" + month;
      if (ri < 10) ri = "0" + ri;
      this.newDate = year + "." + month + "." + ri;
    }

    this.price = this.$route.query.price;
    this.getList();
    this.getGongsi();
    this.getUserINfo();
    this.getDate();
  },

  activated() {
    this.theme = sessionStorage.getItem("theme");
  },
  methods: {
    getId(name, title) {
      for (var i = 0; i < this.list.length; i++) {
        if (name == i) {
          this.agreementId = this.list[i].id;
        }
      }
    },
    getDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var ri = date.getDate();
      if (month < 10) month = "0" + month;
      if (ri < 10) ri = "0" + ri;
      this.date = year + "." + month + "." + ri;
    },
    getUserINfo() {
      var that = this;
      api.getCertificationInfo({}).then((res) => {
        if (res.code == 200) {
          that.userName = res.data.name;
          that.userphone = res.data.phone;
          that.idCard = res.data.idCard;
        } else if (res.code == 401) {
          setTimeout(() => {
            that.getUserINfo();
          }, 1000);
        }
      });
    },
    DateAdd(interval, number, date) {
      /*
       *   功能:实现baiVBScript的DateAdd功能.
       *   参数duzhi:interval,字符串表达式，表示要添加的dao时间间隔.
       *   参数:number,数值表达式，表示要添加的时间间隔的个数.
       *   参数:date,时间对象.
       *   返回:新的时间对象.
       *   var   now   =   new   Date();
       *   var   newDate   =   DateAdd( "d ",5,now);
       *---------------   DateAdd(interval,number,date)   -----------------
       */ switch (interval) {
        case "y ": {
          date.setFullYear(date.getFullYear() + number);
          return date;
          break;
        }
        case "q ": {
          date.setMonth(date.getMonth() + number * 3);
          return date;
          break;
        }
        case "m ": {
          date.setMonth(date.getMonth() + number);
          return date;
          break;
        }
        case "w ": {
          date.setDate(date.getDate() + number * 7);
          return date;
          break;
        }
        case "d ": {
          date.setDate(date.getDate() + number);
          return date;
          break;
        }
        case "h ": {
          date.setHours(date.getHours() + number);
          return date;
          break;
        }
        case "m ": {
          date.setMinutes(date.getMinutes() + number);
          return date;
          break;
        }
        case "s ": {
          date.setSeconds(date.getSeconds() + number);
          return date;
          break;
        }
        default: {
          date.setDate(d.getDate() + number);
          return date;
          break;
        }
      }
    },
    getGongsi() {
      var that = this;
      let params = {
        type: 1,
      };
      api.getCompanyInfo(params).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          that.name = res.data.name;
          that.certificateNo = res.data.certificateNo;
          that.principal = res.data.principal;
          that.ads = res.data.ads;
          that.phone = res.data.phone;
          that.complaintsPhone = res.data.complaintsPhone;
          that.ctime = res.data.ctime;
          that.imgUrl = res.data.imgUrl;
          that.agreementNo = res.data.agreementNo;
        } else if (res.code == 401) {
          setTimeout(() => {
            that.getGongsi();
          }, 1000);
        }
      });
    },
    Init() {
      this.canvas.addEventListener(
        "touchstart",
        (event) => {
          if (event.targetTouches.length == 1) {
            event.preventDefault(); // 阻止浏览器默认事件，重要
            var touch = event.targetTouches[0];

            this.touchPressed = true;
            this.draw(
              touch.pageX - this.canvas.offsetLeft,
              touch.pageY - this.canvas.offsetTop,
              false
            );
          }
        },
        false
      );
      this.canvas.addEventListener(
        "touchmove",
        (event) => {
          if (event.targetTouches.length == 1) {
            event.preventDefault(); // 阻止浏览器默认事件，重要
            var touch = event.targetTouches[0];
            if (this.touchPressed) {
              this.draw(
                touch.pageX - this.canvas.offsetLeft,
                touch.pageY - this.canvas.offsetTop,
                true
              );
            }
          }
        },
        false
      );
      this.canvas.addEventListener(
        "touchend",
        (event) => {
          if (event.targetTouches.length == 1) {
            event.preventDefault(); // 阻止浏览器默认事件，防止手写的时候拖动屏幕，重要
            this.touchPressed = false;
          }
        },
        false
      );
    },
    draw(x, y, isDown) {
      let ctx = this.ctx;
      if (isDown) {
        ctx.beginPath();
        ctx.strokeStyle = this.strokeStyle;
        ctx.lineWidth = this.lineWidth;
        ctx.lineJoin = "round";
        ctx.moveTo(this.lastX, this.lastY);
        ctx.lineTo(x, y);
        ctx.closePath();
        ctx.stroke();
      }
      this.lastX = x;
      this.lastY = y;
    },
    clearArea() {
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    },
    saveImageInfo() {
      // console.log(this.canvas);
      function isCanvasBlank(canvas) {
        var blank = document.createElement("canvas"); //系统获取一个空canvas对象
        blank.width = canvas.width;
        blank.height = canvas.height;
        return canvas.toDataURL() == blank.toDataURL(); //比较值相等则为空
      }
      if (isCanvasBlank(this.canvas)) {
        Toast("请确认您是否已签名！");
        return;
      } else {
        var imgBase64 = this.canvas.toDataURL();
        let fileName = "aaa.png";
        let arr = imgBase64.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let bytes = atob(arr[1]); // 解码base64
        let n = bytes.length;
        let ia = new Uint8Array(n);
        while (n--) {
          ia[n] = bytes.charCodeAt(n);
        }
        var file = new File([ia], fileName, { type: mime });
        let formData = new FormData();
        formData.append("webkitRelativePath", "../aa.png"); // path 路径
        // policy
        formData.append("upload", file, file.name);
        api.getUpload(formData).then((res) => {
          if (res.code == 200) {
            let params = {
              img: res.url,
              agreementId: this.agreementId,
              productId: getUrlParams("id"),
              orderType: 3,
            };
            // console.log(params);
            api.getAgreementSave(params).then((res) => {
              if (res.code == 200) {
                sessionStorage.setItem("a", "a");
                this.$router.go(-1);
                Toast("上传成功");
                this.show = false;
              }
            });
          }
        });
      }
    },

    getList() {
      api.getAgreementList({}).then((res) => {
        if (res.code == 200) {
          this.list = res.data;
          this.agreementId = this.list[0].id;
        } else if (res.code == 401) {
          setTimeout(() => {
            this.getList();
          }, 1000);
        }
      });
    },
    qianziClick() {
      this.show = true;
      this.$nextTick(() => {
        let canvas = document.getElementById("myCanvas");
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
        let winW = window.innerWidth - 80;
        let winH = window.innerHeight - 400;
        canvas.width = winW;
        canvas.height = winH;
        this.Init();
      });
    },
  },
};
</script>

<style  scoped>
.fengxian {
  padding: 0.52rem 0.28rem 0 0.32rem;
}
.fengxian h2 {
  height: 0.5rem;
  font-size: 0.34rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.5rem;
  padding-bottom: 0.28rem;
}
.fengxian p {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 0.44rem;
}
.right {
  margin: 15px 0 0 0;
}
.btn {
  width: 100%;
  height: 1.68rem;
  position: fixed;
  bottom: 0;
  /* left: 0.32rem; */
  background: #fff;
}
button {
  width: 6.86rem;
  height: 0.84rem;
  background: rgba(244, 67, 54, 1);
  border-radius: 2px;
  color: #fff;
  text-align: center;
  margin-top: 0.2rem;
  margin-left: 0.32rem;
  line-height: 0.84rem;
  font-size: 0.34rem;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 6.3rem;
  height: 8rem;
  background-color: #fff;
}
.footer {
  height: 55px;
  width: 100%;
  display: flex;
  padding-top: 0.3rem;
  border-top: 1px solid #ccc;
  justify-content: space-around;
}
.footer div {
  width: 2.4rem;
  height: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.quxiao {
  color: #666;
  border: 1px #ccc solid;
}
.baocun {
  border: 1px #f44336 solid;
  background: #f44336;
  color: #fff;
}
</style>